/**
 * Cashier Methods Collection
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var portalConfig = require('config');
    var server = require('server');
    var cashierConfig = require('portlets/cashier/cashier.config');
    var CashierMethodCollection = require('portlets/cashier/cashier.method.collection');

    module.exports = CashierMethodCollection.extend({
        isQuickDepositTotalizator: false,

        initialize: function(models, options) {
            options = options || {};

            this.paymentMethodsOrder = options.paymentMethodsOrder
                || this.paymentMethodsOrder || 'byCasinoConfiguration';

            this.isQuickDepositTotalizator = Boolean(options?.config?.isQuickDepositTotalizator);
            if (options.suggestDepositAmounts != null) {
                this.suggestDepositAmounts = options.suggestDepositAmounts;
            }

            this.config = options.config || {};
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                var methodsRequest = {
                    ID: 33001,
                    description: 'Get Payment Method list.',
                    type: this.paymentMethod,
                    correlationId: this.getCorrelationId(),
                    byplayerhistory: this.paymentMethodsOrder === 'byPlayerHistory' || this.isQuickDepositTotalizator,
                    bycountrypopularity: this.paymentMethodsOrder === 'byCountryPopularity',
                    bycasinoconfiguration: this.paymentMethodsOrder === 'byCasinoConfiguration' || this.isQuickDepositTotalizator,
                    cancreatenewaccount: true,
                    limits: true,
                    suggestions: this.suggestDepositAmounts,
                    returnaccountfields: true,
                    responses: [33002, 33003]
                };

                if (portalConfig.get('returnBlockedPaymentMethods')) {
                    methodsRequest.returnBlockedMethods = true;
                }

                var methods = server.send(methodsRequest);

                var accounts = server.send({
                    ID: 33011,
                    description: 'Get Payment Method Accounts',
                    correlationId: this.getCorrelationId(),
                    responses: [33012, 33013]
                });

                return $.when(methods, accounts).done(function(mtds, accs) {
                    options.success({
                        methods: mtds,
                        accounts: accs
                    });
                }).fail(options.error);
            }
        },

        parse: function(response) {
            var config = cashierConfig();
            var hideParentPaymentMethods = this.config.hideParentPaymentMethods;
            var methods = response.methods.data.payments ? response.methods.data.payments.method : [];
            var accounts = response.accounts.data.payments
                ? _.indexBy(response.accounts.data.payments.method, 'code')
                : {};
            var subMethods = {};

            var getSubMethods = function(method) {
                if (!method.subMethods) {
                    return;
                }

                _.each(method.subMethods.subMethod, function(subMethod) {
                    if (!subMethods[method.code]) {
                        subMethods[method.code] = [];
                    }

                    subMethods[method.code].push(
                        _.extend(
                            _.omit(method, 'subMethods'),
                            {
                                code: subMethod.code,
                                methodCode: method.code,
                                name: subMethod.name,
                                ordering: subMethod.ordering,
                                reDirectType: subMethod.reDirectType || method.reDirectType,
                                isSubMethod: true
                            }
                        )
                    );
                });
            };

            var addSubMethods = function(res, method) {
                if (subMethods[method.code]) {
                    _.each(subMethods[method.code], function(subMethod) {
                        res[subMethod.code] = subMethod;
                    });
                }
                res[method.code] = method;
                return res;
            };

            var filterParentMethods = function(method) {
                return !(hideParentPaymentMethods && method.hideParentMethod && subMethods[method.code]);
            };

            methods = _.chain(methods)
                .each(this.addCommonFields.bind(this))
                .each(getSubMethods)
                .reduce(addSubMethods, {})
                .filter(filterParentMethods)
                .each(this.mergeWithAccountFields.bind(this, accounts))
                .each(this.removeHiddenAccounts)
                .filter(this.removeCreditCardMethodsWithNoAccounts.bind(this, config))
                .value();

            methods = this.afterParse(methods, config, response);

            return methods;
        }
    });
});
